import React from "react";
import MainTitle from "../MainTitle/MainTitle";
export default function Main() {
  return (
    <main className="" id="Home">
      {/* Header Background image */}
      <div className="w-full h-screen relative -mt-28 pt-20">
        <div className="absolute inset-0 w-full h-full bg-main-bg bg-cover opacity-20 -z-10"></div>
        <MainTitle />
      </div>
    </main>
  );
}
